import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "./components/Content";
import { CircularProgress, Grid } from "@mui/material";
import PrivateRoutes from "./components/PrivateRoutes";
import { OnBehalfProvider } from "./context/OnbehalfContext";
import TermsAndConditions from "./pages/TermsAndConditions";
import ChangePassword from "./pages/ChangePassword";
import ThirdPartyCookieWarning from "./common/ThirdPartyCookieWarning ";
import { areThirdPartyCookiesBlocked } from "./utils/cookieCheck";
import detectBrowser from "./utils/detectBrowser";
const NoMatch = React.lazy(() => import("./pages/NoMatch"));
const Layout = React.lazy(() => import("./pages/Layout"));
const IntegratedLogin = React.lazy(() => import("./pages/IntegratedLogin"));
const SignIn = React.lazy(() => import("./pages/SignIn"));
const ForgotPassword = React.lazy(() => import("./pages/ForgotPassword"));

export default function App() {
  const browser = detectBrowser();
  let blocked = false;
  if (browser === "Firefox") {
    blocked = areThirdPartyCookiesBlocked();
  }
  return (
    <>
      <ThirdPartyCookieWarning />

      {!blocked && (
        <OnBehalfProvider>
          <React.Suspense
            fallback={
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                height={"100vh"}
              >
                <CircularProgress color="primary" />
              </Grid>
            }
          >
            <Routes>
              <Route path="/" element={<SignIn />} />
              <Route path="forgot" element={<ForgotPassword />} />
              <Route
                element={
                  <PrivateRoutes>
                    <Layout showtabsnav />
                  </PrivateRoutes>
                }
                path="/*"
              >
                {routes.map((route, i) => (
                  <Route
                    key={i}
                    element={
                      <PrivateRoutes>
                        <route.component showtabsnav />
                      </PrivateRoutes>
                    }
                    path={route.path}
                  />
                ))}

                <Route path="*" element={<NoMatch />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace={true} />} />

              <Route path="terms" element={<TermsAndConditions />} />

              <Route path="integratedlogin" element={<IntegratedLogin />} />
              <Route
                path="change-password"
                element={<ChangePassword changePass={true} />}
              />
            </Routes>
          </React.Suspense>
        </OnBehalfProvider>
      )}
    </>
  );
}
